import * as THREE from 'three';
import { G, mesh } from '../render/scene';
import { MAT_P, coreGlow } from '../render/materials';
import { bevel, joint, mark, plate, ram, rib } from './mech-kit';
import { POSE } from './mech-pose';
/* ============================================================
   主武器 MAIN：整條右臂（1:1 移植自 mech_sample_ani.html）
   ============================================================

   上臂／前臂都是「上段厚、下段收」—— 質量集中在關節上方，
   這是把積木堆變成肢體的關鍵。 */

/* 主武器 MAIN：整條右臂（-X）。上臂／前臂都是「上段厚、下段收」。 */
function armBase(g) {
  g.add(joint(0.23, [0, 0, 0], true));                                         // 肩關節（軸端外露）
  var up = new THREE.Group(); up.userData.bone = 1;
  up.rotation.set(POSE.armPitch, POSE.armYaw, POSE.armRoll);                   // 手臂外張舉起
  g.add(up);
  up.add(bevel(MAT_P.dark,  0.34, 0.44, 0.34, [0, -0.24, 0]));                     // 上臂上段（厚）
  up.add(bevel(MAT_P.dark,  0.27, 0.42, 0.27, [0, -0.63, 0]));                     // 上臂下段（收）
  up.add(ram  ([ 0.19, -0.52, -0.13], 0.52, 0.09, 0.075, [0.10, 0, 0]));           // 肘部液壓
  up.add(plate(MAT_P.armor, 0.24, 0.88, 0.94, [-0.40, 0.16, 0], 0.10, -0.18, 0.22));// 肩甲（上揚）
  up.add(rib  (MAT_P.armor, 0.10, 0.10, 0.94, [-0.44, 0.58, 0], 0.10, -0.18, 0.22));// 上緣亮線
  var el = new THREE.Group(); el.position.set(0, -0.88, 0); up.add(el);
  el.add(joint(0.19, [0, 0, 0]));                                              // 肘關節
  var fo = new THREE.Group(); fo.userData.bone = 1;
  fo.rotation.x = -1.30; el.add(fo);                                           // 前臂向前平舉
  var aim = new THREE.Group(); aim.userData.bone = 1;
  aim.rotation.z = POSE.aimConverge; fo.add(aim);                              // 槍口再往內收，交匯
  g.userData.rig = { up: up, fore: fo, aim: aim };
  return aim;
}
export function buildMain(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['main-pierce', 'main-chain', 'main-vulcan']);
  var fo = armBase(g);
  g.userData.muzzle = shape === 'main-pierce' ? -2.30 : shape === 'main-chain' ? -1.88 : -1.70;

  if (shape === 'main-pierce'){
    fo.add(bevel(MAT_P.dark,  0.34, 0.40, 0.34, [0, -0.22, 0]));
    fo.add(bevel(MAT_P.dark,  0.27, 0.38, 0.27, [0, -0.58, 0]));
    fo.add(plate(MAT_P.armor, 0.42, 0.62, 0.40, [0, -0.32, 0.12], 0));
    fo.add(rib  (MAT_P.armor, 0.07, 0.66, 0.07, [ 0.18, -0.32, 0.15], 0));         // 前臂稜線 ×2
    fo.add(rib  (MAT_P.armor, 0.07, 0.66, 0.07, [-0.18, -0.32, 0.15], 0));
    fo.add(mesh (G.cyl,   MAT_P.trim,  [0.19, 1.34, 0.19], [0, -1.40, 0]));        // 長砲管
    fo.add(mesh (G.box,   MAT_P.armor, [0.13, 1.08, 0.10], [0, -1.34, 0.19]));     // 上方導軌
    fo.add(mesh (G.box,   MAT_P.dark,  [0.12, 0.14, 0.20], [0, -0.95, 0.17]));
    fo.add(mesh (G.box,   MAT_P.dark,  [0.12, 0.14, 0.20], [0, -1.72, 0.17]));
    fo.add(mesh (G.box,   P.glow,  [0.05, 0.88, 0.04], [0, -1.34, 0.25]));
    fo.add(mesh (G.cone,  MAT_P.trim,  [0.30, 0.34, 0.30], [0, -2.13, 0], [Math.PI, 0, 0]));

  } else if (shape === 'main-chain'){
    fo.add(bevel(MAT_P.dark,  0.36, 0.40, 0.36, [0, -0.22, 0]));
    fo.add(bevel(MAT_P.dark,  0.28, 0.38, 0.28, [0, -0.58, 0]));
    fo.add(plate(MAT_P.armor, 0.44, 0.62, 0.42, [0, -0.32, 0.12], 0));
    fo.add(rib  (MAT_P.armor, 0.07, 0.66, 0.07, [ 0.19, -0.32, 0.16], 0));
    fo.add(rib  (MAT_P.armor, 0.07, 0.66, 0.07, [-0.19, -0.32, 0.16], 0));
    fo.add(mesh (G.cyl,   MAT_P.trim,  [0.17, 0.94, 0.17], [0, -1.18, 0]));
    fo.add(mesh (G.tor,   P.glow,  [0.42, 0.42, 0.16], [0, -0.94, 0], [Math.PI / 2, 0, 0]));
    fo.add(mesh (G.tor,   P.glow,  [0.40, 0.40, 0.16], [0, -1.18, 0], [Math.PI / 2, 0, 0]));
    fo.add(mesh (G.tor,   P.glow,  [0.38, 0.38, 0.16], [0, -1.42, 0], [Math.PI / 2, 0, 0]));
    fo.add(mesh (G.cone,  MAT_P.armor, [0.30, 0.32, 0.30], [0, -1.72, 0], [Math.PI, 0, 0]));
    fo.add(mesh (G.box,   MAT_P.dark,  [0.30, 0.26, 0.22], [0, -0.72, -0.24]));

  } else {  /* main-vulcan */
    fo.add(bevel(MAT_P.dark,  0.36, 0.40, 0.36, [0, -0.22, 0]));                   // 前臂上段（厚）
    fo.add(bevel(MAT_P.dark,  0.28, 0.38, 0.28, [0, -0.58, 0]));                   // 前臂下段（收）
    fo.add(plate(MAT_P.armor, 0.44, 0.62, 0.42, [0, -0.32, 0.12], 0));
    fo.add(rib  (MAT_P.armor, 0.07, 0.66, 0.07, [ 0.19, -0.32, 0.16], 0));
    fo.add(rib  (MAT_P.armor, 0.07, 0.66, 0.07, [-0.19, -0.32, 0.16], 0));
    fo.add(bevel(MAT_P.trim,  0.30, 0.44, 0.30, [0, -0.94, 0]));
    fo.add(mesh (G.cyl,   MAT_P.trim, [0.16, 0.56, 0.16], [0, -1.32, 0]));         // 短砲管
    fo.add(mesh (G.tor,   MAT_P.dark, [0.30, 0.30, 0.14], [0, -1.56, 0], [Math.PI / 2, 0, 0]));
    fo.add(mesh (G.box,   MAT_P.dark, [0.34, 0.30, 0.24], [0, -0.80, -0.26]));
    fo.add(mesh (G.box,   P.glow, [0.08, 0.20, 0.06], [0, -0.80, -0.40]));
  }
  return g;
}
